class SubcollectionsSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    console.log('yo!')
    // Use setTimeout to ensure DOM is fully ready
    setTimeout(() => {
      this.init();
    }, 0);
  }

  init() {
    this.track = this.querySelector('[data-carousel-track]');
    this.nav = this.querySelector('[data-carousel-nav]');
    this.prevButton = this.querySelector('[data-nav-prev]');
    this.nextButton = this.querySelector('[data-nav-next]');

    if (!this.track) {
      console.warn('SubcollectionsSlider: Track element not found');
      return;
    }

    // Check if content overflows (needs scrolling)
    const needsScrolling = this.track.scrollWidth > this.track.offsetWidth;

    if (needsScrolling) {
      this.nav.style.display = 'block';
    }

    if (!needsScrolling && this.prevButton && this.nextButton) {
      // Hide navigation if content doesn't overflow
      this.prevButton.style.display = 'none';
      this.nextButton.style.display = 'none';
      return;
    }

    this.setupNavigation();
    this.updateButtonStates();

    // Throttle scroll events for better performance
    let scrollTimeout;
    this.track.addEventListener('scroll', () => {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      scrollTimeout = setTimeout(() => {
        this.updateButtonStates();
      }, 10);
    });

    // Update on resize
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(() => {
        this.updateButtonStates();
      });
      resizeObserver.observe(this.track);
    }
  }

  setupNavigation() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.scroll('prev');
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.scroll('next');
      });
    }
  }

  scroll(direction) {
    if (!this.track) return;

    const scrollAmount = this.track.offsetWidth * 0.8;
    const currentScroll = this.track.scrollLeft;

    if (direction === 'next') {
      this.track.scrollTo({
        left: currentScroll + scrollAmount,
        behavior: 'smooth'
      });
    } else {
      this.track.scrollTo({
        left: currentScroll - scrollAmount,
        behavior: 'smooth'
      });
    }
  }

  updateButtonStates() {
    if (!this.track) return;
    if (!this.prevButton || !this.nextButton) return;

    const isAtStart = this.track.scrollLeft <= 1;
    const isAtEnd = this.track.scrollLeft + this.track.offsetWidth >= this.track.scrollWidth - 1;

    this.prevButton.disabled = isAtStart;
    this.nextButton.disabled = isAtEnd;
  }
}

// Only define if not already defined
if (!customElements.get('subcollections-slider')) {
  customElements.define('subcollections-slider', SubcollectionsSlider);
}
